import { DownOutlined } from "@ant-design/icons";
import { Collapse, Row } from "antd";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./TermsAndCondition.module.scss";
import { termsData } from "./data";
import { useState } from "react";

const TermsAndCondition = () => {
    const [activeKey, setActiveKey] = useState(0);

    const onAccordionChange = (key) => {
        setActiveKey(key);
    };

    return (
        <Layout title="General Terms & Condition">
            <div className={`${styles.wrapper} container`}>
                <BreadCrumb
                    list={[
                        { name: "Home", link: "/" },
                        { name: "Service", link: "/terms-and-condition" },
                        { name: "AGB", link: "/terms-and-condition" },
                    ]}
                />
                <div className={styles.terms_wrapper}>
                    <h2 className={styles.title}>
                        General terms and conditions{" "}
                    </h2>
                    <p className={styles.date}>
                        <strong>(as of 03/22/2023)</strong>
                    </p>

                    <div style={{ marginBottom: 5 }}>
                        If you order products from DESI FRESH via online shop,
                        the following provisions apply.
                    </div>

                    <div>
                        If you want to commission a DESI FRESH retailer to
                        provide the delivery service on desifresh.co, please
                        note that DESI FRESH Market GmbH acts as an intermediary
                        here and that the general terms and conditions of the
                        DESI FRESH retailer you have selected apply to the
                        provision of services. Merchants apply.
                    </div>

                    {/* accordion */}
                    <Row>
                        <div className={styles.questions}>
                            <Collapse
                                accordion={true}
                                ghost={true}
                                expandIcon={({ isActive }) => (
                                    <DownOutlined
                                        size={20}
                                        rotate={isActive ? 180 : 0}
                                        style={{
                                            color: isActive && "green",
                                        }}
                                    />
                                )}
                                bordered={false}
                                expandIconPosition="end"
                                activeKey={activeKey}
                                onChange={onAccordionChange}
                            >
                                {termsData.map((item) => (
                                    <Collapse.Panel
                                        header={
                                            <span
                                                style={{
                                                    marginLeft: 5,
                                                    color:
                                                        +activeKey === item.key
                                                            ? "green"
                                                            : "",
                                                }}
                                            >
                                                {item.question}
                                            </span>
                                        }
                                        key={item.key}
                                    >
                                        <span>{item.answer}</span>
                                    </Collapse.Panel>
                                ))}
                            </Collapse>
                        </div>
                    </Row>
                </div>
            </div>
        </Layout>
    );
};

export default TermsAndCondition;
